/**
 * The product videos, hosted in our own public R2 bucket rather than on a video platform.
 *
 * Linked from the welcome screen and the documentation page, which is why the URL lives here rather
 * than in either of them. They are plain links that open in a new tab — the files are 1080p and
 * playing one inside the app would fight the workspace for the tab's bandwidth. Note that embedding
 * one in a `<video>` element would additionally need this host added to the CSP, which has no
 * `media-src` and so falls back to `default-src 'self'` (see config/securityHeaders.ts).
 */

export const WALKTHROUGH_VIDEO_URL = 'https://www.videos.censorme.app/howto-1080p.mp4';

/** The file's real running time. Re-check it if the video is ever re-cut. */
export const WALKTHROUGH_VIDEO_LENGTH = '9 min';

/** What the walkthrough covers, for anywhere that wants to list it rather than prose it. */
export const WALKTHROUGH_VIDEO_CHAPTERS = [
  'Uploading your audio and transcribing it',
  'Building a word list and converting to XML',
  'Importing the timeline into Premiere Pro and DaVinci Resolve',
  'Relinking your source audio when it opens offline',
  'Using CensorMe Mapper to repair paths in an XML you already have',
];
